import axios from 'axios'
import Vue from 'vue'
import router from '.././router'
import store from '../store/index'
import G from '@/views/common/global'
import {getToken} from '@/utils/auth'

const service = axios.create({
    // baseURL: "http://localhost:6789",
    baseURL: G.BASE_URL,
    timeout: 30000,
    //add lk 2020.4.10 start
    withCredentials: true,
    // add lk 2020.4.10 end
})

service.interceptors.request.use(
    config => {
        //edit by cyt 2021.4.14 start
        //add lk 2020.4.13 start
        // let token = store.state.token.token
        // let token = sessionStorage.getItem('token')
        //add lk 2020.4.13 end
        // if (token) {
        //     let sp = "?"
        //     if (config.url.indexOf("?") >= 0) {
        //         sp = "&"
        //     }
        //     config.url = config.url + sp + "access_token=" + token
        // }
        if (getToken()) {
            config.headers['Authorization'] = 'Bearer ' + getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
        }
        //edit by cyt 2021.4.14 end
        return config
    },
    error => {

    }
)


service.interceptors.response.use(
    response => {
        let responseJson = response.data
       // console.log("response.data.Blob ")
    //    console.log("response",response)
    //    if(response.data.code == 200){
    //        console.log("重定向")
    //        router.push('/')
    //    }
      if(response.request.responseType=='blob'){
        return response
      }else{
        return responseJson
      }
    },
    error => {
        let message
        switch (error.response.status) {
            case 401:
                message = "Token错误"
                break
            default:
                message = error.response.data.message
                break
        }
        Vue.prototype.$message({
            message: message,
            type: 'error'
        })
        return Promise.reject('error')
    }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js